/**
 * API service for the Planned Headcount page
 */
import { store } from '../../../store';
import { apiRequest } from '../../../services/apiMiddleware';
import { API_GATEWAY_PROCESS_NAME } from '../../../utils/constants';
import { GetPlannedHeadcountRequest, GetPlannedHeadcountResponse } from './models';
import { showError } from '../../../store/slices/errorSlice';

const EMPTY_RESPONSE: GetPlannedHeadcountResponse = {
  planStatus: undefined,
  primaryPaths: [],
  supportPaths: [],
};

export const getPlannedHeadcount = async (
  warehouseId: string,
  planId: string,
): Promise<GetPlannedHeadcountResponse> => {
  try {
    if (!warehouseId) {
      store.dispatch(showError({
        title: 'Warehouse ID Required',
        message: 'Please select a valid warehouse ID from the dropdown',
      }));
      return EMPTY_RESPONSE;
    }

    const requestBody: GetPlannedHeadcountRequest = {
      warehouseId,
      planId,
    };

    const requestPayload = {
      resourcePath: '/getPlannedHeadcount',
      httpMethod: 'post',
      processName: API_GATEWAY_PROCESS_NAME,
      requestBody,
    };

    const response = await apiRequest(requestPayload);

    if (response.status && response.status >= 400) {
      store.dispatch(showError({
        title: 'Failed to fetch planned headcount data',
        message: response.errorResponse || 'Unable to fetch planned headcount data. Please try again later.',
      }));
      return EMPTY_RESPONSE;
    }

    return response.data;
  } catch (error: any) {
    console.error('Error fetching planned headcount data:', error);
    store.dispatch(showError({
      title: 'Failed to fetch planned headcount data',
      message: error.errorResponse || error.message || 'Unable to fetch planned headcount data. Please try again later.',
    }));
    return EMPTY_RESPONSE;
  }
};
